import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const TextStroke = styled(Text)`
	color: white;
	text-shadow:
		1px 0 0 rgba(0, 0, 0, 0.25),
		0 1px 0 rgba(0, 0, 0, 0.25),
		-1px 0 0 rgba(0, 0, 0, 0.25),
		0 -1px 0 rgba(0, 0, 0, 0.25);
`;

export { TextStroke };
